import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-blocked-account',
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: './deactivate-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './deactivate-dialog.component.scss',
})
export class DeactivatedAccountComponent {
  translate = inject(TranslateService);
}
